import { getPubAbbr } from "@revbox/helpers-fe";
import { cookiesKeyNames } from "@revbox/common-fe";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function NameRenderer({ value }) {
    const {
        cookiesData,
        getPathKey,
    } = useCookiesContext();
    const publisherId = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId];

    const name = value.split("@")[0];
    const visits = value.split("@")[1];
    const forecasting = value.split("@")[2];

    // Check if forecasting is enabled (handle boolean, string, null, undefined)
    // Show views badge when forecasting is enabled (true or 'true'), hide otherwise
    const isForecastingDisabled = forecasting === 'false' || forecasting === false || forecasting === 'null' || forecasting === null || forecasting === undefined || forecasting === 'undefined';
    const isForecastingEnabled = !isForecastingDisabled;

    if (publisherId != 67 && publisherId != 10) {
        return (
            <div className="d-flex align-items-center table-item-name">
                {name}
                {isForecastingEnabled && (
                    <span className='badge bg-outline-secondary badg m-2'>{visits} Views</span>
                )}
            </div>
        );
    } else {
        return (
            <div className="d-flex align-items-center table-item-name">
                {name}
            </div>
        );
    }
}

export function NameColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    let tooltip = taxonomy.tooltips.ppc_specific_column_headers.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}

export function NameCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    
    const name = value.split("@")[0];
    const visits = value.split("@")[1];

    let tooltip = taxonomy.tooltips.ppc_specific_column_inlines.name;

    return tooltip; // `Current invetory recived ${visits} visits per last 30 days`;
}
 